import { motion } from 'framer-motion'
import React from 'react'
import { Container } from 'react-bootstrap'
import Footer from '../components/Footer'
import PageWrapper from '../components/PageWrapper'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'

export default function ShuttleService() {
    return (
      <motion.div 
      initial={{ y: -150, opacity: 0}}
      animate={{ y:0, opacity: 1}}
      exit={{ opacity: 0 }}>
        <PageSeo h1="Shuttle Service" />
        <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
          <PageWrapper name={'Shuttle'} display={<h1 className="txt-big">Shuttle Service</h1>}>
            <span className="txt-cream txt-shadow">Montego Bay (MoBay) airport shuttle and hotel transfers on Jamaica&apos;s north coast.</span>
          </PageWrapper>
          <Container className="text-cream mb-5" style={{ maxWidth: '70ch' }}>
            <p>
              Reggae Wheels provides group-friendly shuttle buses for Sangster International Airport (Montego Bay),
              cruise terminals, and hotels around Discovery Bay, Ocho Rios, and nearby resort areas.
            </p>
            <p>
              Contact us through the About page to coordinate pick-up times and group size — we&apos;ll confirm availability
              for your travel date.
            </p>
          </Container>
          <Footer></Footer>
      </motion.div>
      )
}
